import store from '@/store'
export default {
    mounted(el, binding) {
        let permission = binding.value;
        if (permission) {
            let authCodes = store.state.app.userInfo.permissions
            let hasPermission = authCodes.includes(permission);
            if (!hasPermission) {

                el.parentNode && el.parentNode.removeChild(el);
            }
        }
    }
}
